import React, { useState } from 'react'
import { Popover as TinyPopover, ArrowContainer } from 'react-tiny-popover'

import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'
import InfoIcon from 'react-icons/lib/fa/info-circle'

import './styles'

ARROW_SIZE = 8
ARROW_COLOR = '#F0F0F0'

export default Popover = ({ warning, title, children }) ->
  return null unless children

  [isOpen, setIsOpen] = useState false
  [isPreview, setIsPreview] = useState false

  onClosePopover = ->
    setIsOpen false
    setIsPreview false

  onTogglePopover = -> setIsOpen (prevState) -> not prevState

  popoverIcon = ->
    if warning
      <WarningIcon className="warning-icon" />
    <InfoIcon className="info-icon" />

  popoverTitle = ->
    if title
      title
    else if warning
      "Warnings"
    else
      "Contd."

  popoverContent = ({ position, childRect, popoverRect }) ->
    <ArrowContainer
      arrowSize={ARROW_SIZE}
      arrowColor={ARROW_COLOR}
      className='PopoverContainer'
      {...{ position, childRect, popoverRect }}
    >
      <div className="content">
        <div className="headerContainer">
          <h5 className="header">{popoverTitle()}</h5>
          { <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={onClosePopover}
            >
              <span aria-hidden="true">&times;</span>
            </button> if isOpen }
        </div>
        {children}
      </div>
    </ArrowContainer>

  <div
    className="Popover"
    onMouseEnter={() => setIsPreview(true)}
    onMouseLeave={() => setIsPreview(false)}
  >
    <TinyPopover
      isOpen={isPreview or isOpen}
      onClickOutside={onClosePopover}
      positions={['left', 'bottom', 'right']}
      padding={4}
      content={(content) -> popoverContent content}
    >
      <div
        className="icon-container"
        onClick={onTogglePopover}
      >
        {popoverIcon()}
      </div>
    </TinyPopover>
  </div>
